import angular from 'angular';
import geolocation from 'angularjs-geolocation';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import datepicker from 'angular-ui-bootstrap/src/datepicker';
import 'angular-bootstrap-checkbox';

// Dependencies
import servicesModuleName from '../../../../../lib/service';
import geoServiceModule from '../../../../../lib/service/GeoService';

// Translations
import translate from '../../../../../lib/translation';

// Controller
import GuerrillaModalController from './guerrillaModal.controller';
import template from './guerrillaModal.html';

const moduleName = 'staff.dashboardScreen.guerrillaModal';
let module = angular.module(moduleName, [
  servicesModuleName,
  datepickerPopup,
  datepicker,
  geoServiceModule.name,
  uiModal,
  'geolocation',
  translate,
  'ui.checkbox',
  'angularMoment',
]);

module.controller('GuerrillaModalController', GuerrillaModalController);

module.factory('guerrillaModal', ['$uibModal', '$q', ($uibModal, $q, date) => {
  return props => {

    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: GuerrillaModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        $q: () => $q,
        position: props.position,
        staffUser: props.staffUser
      }
    });
    return modal.result;
  };
}]);

module.directive('datetimepickerNeutralTimezone', function() {
  return {
    restrict: 'A',
    priority: 1,
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$formatters.push(function (value) {
        let date = new Date(Date.parse(value));
        date = new Date(date.getTime() + (60000 * date.getTimezoneOffset()));
        return date;
      });

      ctrl.$parsers.push(function (value) {
        let date = new Date(value.getTime() - (60000 * value.getTimezoneOffset()));
        return date;
      });
    }
  };
});

export default module;

